import { render, staticRenderFns } from "./ContratoModeloSocinal.vue?vue&type=template&id=4d1fa8ea&scoped=true&"
import script from "./ContratoModeloSocinal.vue?vue&type=script&lang=js&"
export * from "./ContratoModeloSocinal.vue?vue&type=script&lang=js&"
import style0 from "./ContratoModeloSocinal.vue?vue&type=style&index=0&id=4d1fa8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1fa8ea",
  null
  
)

export default component.exports